<script setup>
import { UserIcon } from 'vue-tabler-icons';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

const showUserCard = ref(false);

const signInDomain = computed(() => store.state.users.signInDomain);
const user = computed(() => store.state.users.user);

const logout = async () => {
  await store.dispatch('users/logout');
  router.go();
};
</script>

<template>
  <div class="user-card relative justify-end px-5">
    <button class="user-card__expand-trigger" @click.prevent="showUserCard = !showUserCard">
      <user-icon class="h-6 w-6" />
    </button>

    <ul
      class="absolute top-8 right-2 z-10 cursor-auto flex-col rounded-lg bg-gray-50 shadow-lg"
      :class="{ flex: showUserCard, hidden: !showUserCard }"
    >
      <li class="user-card__greetings"><small> Greetings </small> {{ user.username }}</li>
      <li class="user-card__client">
        {{ signInDomain }}
        <span class="text-xs"> Switch Client </span>
      </li>
      <li>
        <button role="button" class="user-card__logout" @click="logout">Sign Out</button>
      </li>
    </ul>
  </div>
</template>

<style lang="postcss" scoped>
.user-card__expand-trigger {
  @apply outline-none rounded-full p-1 text-2xl hover:bg-gray-100;
}
.user-card__greetings {
  @apply mx-auto mb-2 rounded-full  px-4 py-2 text-lg capitalize text-black;
}
.user-card__client {
  @apply flex h-full flex-col bg-gray-200 px-5 py-2;
}
.user-card__logout {
  @apply w-full rounded-b-lg border bg-red-300 px-4 py-2 text-sm text-black hover:bg-red-400;
}
</style>
